
import ReactGA from 'react-ga';
import { urlGetBancosCuotas, urlGetRecompraKilometroPaquete } from "../../constants/urls";
import { createAction } from 'redux-actions'

export const RECOMPRA_PAQUETE_HAS_ERRORED = "RECOMPRA_PAQUETE_HAS_ERRORED";
export const BANCOS_CUOTAS_HAS_ERRORED = "BANCOS_CUOTAS_HAS_ERRORED";
export const SET_DATA_RECOMPRA_PAQUETE = "SET_DATA_RECOMPRA_PAQUETE";
export const SET_DATA_RECOMPRA_PAQUETE_ERROR = "SET_DATA_RECOMPRA_PAQUETE_ERROR";
export const SET_DATA_BANCOS_CUOTAS = "SET_DATA_BANCOS_CUOTAS";
export const RECOMPRA_PAQUETE_IS_LOADING = "RECOMPRA_PAQUETE_IS_LOADING";
export const BANCOS_CUOTAS_IS_LOADING = "BANCOS_CUOTAS_IS_LOADING";
export const LIMPIAR_RECOMPRA = "LIMPIAR_RECOMPRA";
export const VALIDAR_PLACAS_POLIZA = "VALIDAR_PLACAS_POLIZA";
export const MSG_VALIDAR_PLACAS_POLIZA = "MSG_VALIDAR_PLACAS_POLIZA";
export const LIMPIAR_DATOS_VALIDACIONES_PLACA = "LIMPIAR_DATOS_VALIDACIONES_PLACA";


ReactGA.initialize('UA-131241061-1');

export const RecompraPaqueteHasErrored = () => ({
  type: RECOMPRA_PAQUETE_HAS_ERRORED
});

export const BancosCuotasHasErrored = () => ({
  type: BANCOS_CUOTAS_HAS_ERRORED
});

export const limpiarDatosRecompra = () => ({
  type: LIMPIAR_RECOMPRA
});
export const RecompraPaqueteIsLoading = (valor) => ({
  type: RECOMPRA_PAQUETE_IS_LOADING,
  isLoading: valor
});
export const BancosCuotasIsLoading = (valor) => ({
  type: BANCOS_CUOTAS_IS_LOADING,
  isLoading: valor
});
export const RecompraPaquete = valor => ({
  type: SET_DATA_RECOMPRA_PAQUETE,
  recompraPaquete: valor
});

export const RecompraPaqueteError = valor => ({
  type: SET_DATA_RECOMPRA_PAQUETE_ERROR,
  recompraPaqueteError: valor
});

export const BancosCuotas = valor => ({
  type: SET_DATA_BANCOS_CUOTAS,
  bancosCuotas: valor
});

export const SetRecompraPaquete = (data = {}) => {
  return dispatch => {
    dispatch(RecompraPaquete(data));
  };
};

export const SetValidarPlacasPoliza = () => ({
  type: VALIDAR_PLACAS_POLIZA
});

export function SetMsgValidarPlacasPoliza(payload) {
  return {
    type: MSG_VALIDAR_PLACAS_POLIZA,
    payload
  };
}
export const limpiarDatosValidacionesPlaca = () => ({
  type: LIMPIAR_DATOS_VALIDACIONES_PLACA
});

// Cotizador Hogar ----------------------------------------------
export const setCarritoHogar = createAction("SET_CARRITO_HOGAR");
export const carritoHogarError = createAction("CARRITO_HOGAR_ERROR");
export const carritoHogarloading = createAction("CARRITO_HOGAR_LOADING");

export const setPlanesHogarAdvance = createAction("SET_PLANES_HOGAR_ADVANCE");
export const planesHogarAdvanceError = createAction("PLANES_HOGAR_ADVANCE_ERROR");
export const planesHogarAdvanceLoading = createAction("PLANES_HOGAR_ADVANCE_LOADING");


export const limpiarCarritoHogar = createAction("LIMPIAR_RECOMPRA_HOGAR");

export const setSeccionesCoberturasHogar = createAction("SET_SECCIONES_COBERTURAS_HOGAR");
export const seccionesCoberturasHogarloading = createAction("SECCIONES_COBERTURAS_HOGAR_LOADING");
export const seccionesCoberturasHogarError = createAction("SECCIONES_COBERTURAS_HOGAR_ERROR");
export const limpiarSeccionesCoberturasHogar = createAction("LIMPIAR_SECCIONES_COBERTURAS_HOGAR");
export const limpiarPlanesHogarAdvance = createAction("LIMPIAR_COBERTURAS_HOGAR_ADVANCE");

export const setCalculoPrimaHogar = createAction("SET_CALCULO_PRIMA_HOGAR");
export const calculoPrimaHogarloading = createAction("CALCULO_PRIMA_HOGAR_LOADING");
export const calculoPrimaHogarError = createAction("CALCULO_PRIMA_HOGAR_ERROR");
export const limpiarCalculoPrimaHogar = createAction("LIMPIAR_CALCULO_PRIMA_HOGAR");

export const setCalculoPrimaHogarErrores = createAction("SET_CALCULO_PRIMA_HOGAR_ERRORES");
export const limpiarErroresCalculoPrimaHogar = createAction("LIMPIAR_ERRORES_CALCULO_PRIMA_HOGAR");

export const setProductoActualHogar = createAction("SET_PRODUCTO_ACTUAL_HOGAR");
export const limpiarProductoActualHogar = createAction("LIMPIAR_PRODUCTO_ACTUAL_HOGAR");

export const setGenerarPdfCotizacionHogar = createAction("SET_GENERAR_PDF_COTIZACION_HOGAR");
export const generarPdfCotizacionHogarloading = createAction("GENERAR_PDF_COTIZACION_HOGAR_LOADING");
export const generarPdfCotizacionHogarError = createAction("GENERAR_PDF_COTIZACION_HOGAR_ERROR");

// manejo duplicidades hogar
export const setDuplicidadPolizaLoading = createAction("SET_DUPLICIDAD_POLIZA_LOADING");
export const setDuplicidadPolizaError = createAction("SET_DUPLICIDAD_POLIZA_ERROR");
export const setIsDuplicatePoliza = createAction("SET_IS_DUPLICATE_POLIZA");

// Fin Cotizador Hogar ----------------------------------------------

// totales cabecera----------------
export const setTotalesCabeceraCotizadores = createAction("SET_TOTALES_CABECERA_COTIZADORES");
export const limpiarTotalesCabeceraCotizadores = createAction("LIMPIAR_TOTALES_CABECERA_COTIZADORES");




//fin totales cabecera -----------


/**
 * 
 * @param {string} idPoliza id de la poliza a consultar
 * @returns {void}
 * Guara información sobre la poliza consultada en el almacén de datos
 */
export const FetchDataRecompraPaquete = (idPoliza, plan, suma, datosAccesorios) => async dispatch => {
  var url = `${urlGetRecompraKilometroPaquete}${idPoliza}${plan ? '&plan=' + plan : ''}${suma ? '&sumaAsegurada=' + suma : ''}`;
  console.log('miurl: ', url)
  dispatch(RecompraPaqueteIsLoading(true));
  await fetch(url, {
    method:'POST',
    body: JSON.stringify( datosAccesorios)
  })
    .then(response => response.json())
    .then(data => {
      if (data.transaccion) {
        const prod = data;
        dispatch(RecompraPaquete(prod));
        dispatch(RecompraPaqueteError(''))
      } else if (!data.transaccion) {

        dispatch(RecompraPaquete(null));
        dispatch(RecompraPaqueteError(data.errorDescripcion))
        dispatch(RecompraPaqueteHasErrored())
      }

      dispatch(RecompraPaqueteIsLoading(false));

    })
    .catch(response => {
      dispatch(RecompraPaqueteHasErrored(false));
      dispatch(RecompraPaquete(null));
      dispatch(RecompraPaqueteIsLoading(false));
      dispatch(RecompraPaqueteError('Existió un error con el servicio'))
      dispatch(RecompraPaqueteHasErrored(false));
    });
};

/**
 * 
 * @param {string} idPoliza id de la poliza a consultar
 * @returns {void}
 * Guara información sobre la poliza consultada en el almacén de datos
 */
export const FetchDataBancosCuotas = () => async dispatch => {
  var url = `${urlGetBancosCuotas}`;
  console.log('miurl: ',url)
  dispatch(BancosCuotasIsLoading(true));
  await fetch(url)
    .then(response => response.json())
    .then(data => {


      if (data.transaccion) {
        const prod = data;
        dispatch(BancosCuotas(prod.bancos));
      } else if (!data.transaccion) {

        dispatch(BancosCuotas(null));
        dispatch(RecompraPaqueteHasErrored())
      }

      dispatch(BancosCuotasIsLoading(false));

    })
    .catch(response => {
      dispatch(RecompraPaqueteHasErrored());
      dispatch(BancosCuotas(null));
      dispatch(RecompraPaqueteIsLoading(false));
    });





  }